
import Footer from "./views/Footer.vue";
import Navigation from "./views/Navigation.vue";

export default {
  name: "Home",
  components: { Footer, Navigation }
};
